// Whether this browser can decode a stored codec hint (spec 2026-10-24: Safari / iOS and Ogg Vorbis → "Can't play
// here", no fallback). Same rule as store/videoPlaybackSupport.ts: "" from canPlayType = no; unknown → assume yes.
const cache = new Map<string, boolean>();

export function canPlayCodec(codec: string | null | undefined, media: "audio" | "video" = "audio"): boolean {
  if (!codec || typeof document === "undefined") return true;
  const key = `${media}|${codec}`;
  const hit = cache.get(key);
  if (hit !== undefined) return hit;
  const ok = document.createElement(media).canPlayType(codec) !== "";
  cache.set(key, ok);
  return ok;
}

export function resetCanPlayForTests(): void {
  cache.clear();
}
